<template>
  <div id="accountblock">
    <audio :src="require('../sound.mp3')" id="notification_sound" :autoplay="false" style="display: none"></audio>
    <template v-if="$store.state.user != null">
      <md-toolbar class="toolbar" :class="getHeaderClass">
        <!-- :style="{backgroundColor: $route.name != 'home' ? '#f1f3f6' : '#fff'}" -->
        <div :class="isOpen || this.routeName == 'home' || this.routeName == 'events' || this.routeName == 'incomingevents' || this.routeName == 'pastevents' ? 'toolbar-inner-grid' : 'toolbar-inner-flex'" class="w-100">
          <md-button
            id="tour-4"
            class="md-icon-button custom-account-button-first"
            @click="
              $root.$emit('toggleMenu');
              localStorage.setItem('isOpen', isOpen);
            "
            style="transition: .3s"
            :style="isOpen ? '' : 'transform: rotate(90deg)'"
            v-if="routeName != 'login' && routeName != 'register' && routeName != 'forgot-password' && routeName != 'home' && routeName != 'events' && routeName != 'incomingevents' && routeName != 'pastevents'"
          >
            <md-icon>
              <i class="fa fa-bars" style="font-size: 16px" />
            </md-icon>
            <md-tooltip md-delay="300">{{ $t("account_bar.side_bar_open") }}</md-tooltip>
          </md-button>

          <div class="mobile-logo" style="background-color:white;" v-if="routeName == 'login' || routeName == 'register' || routeName == 'forgot-password' || routeName == 'home' || routeName == 'events' || routeName == 'incomingevents' || routeName == 'pastevents'">
            <template v-if="$route.params.id == undefined">
              <img v-if="$route.params.slug != 'holacon'" :src="$imageus + $store.state.application.image + '?width=200&height=200)'" class="logo wlabelclass" @click="$router.push({ name: 'events' })" />
              <img v-else src="/static/logo.svg" @click="$router.push({ name: 'events' })" />
            </template>
          </div>

          <md-button class="md-icon-button custom-account-button" @click="requestFullScreen" style="transition: .3s" v-if="innerWidth > 768">
            <md-icon id="tour-5">
              <i style="font-size: 15px" :class="fullScreen ? 'fas fa-compress' : 'fas fa-expand'" />
            </md-icon>
            <md-tooltip md-delay="300">{{ fullScreen ? $t("account_bar.normal_screen") : $t("account_bar.fullscreen") }}</md-tooltip>
          </md-button>

          <md-button class="md-icon-button custom-account-button" @click="goBack" style="transition: .3s" v-if="innerWidth <= 768">
            <md-icon>
              <i style="font-size: 15px" class="fa fa-arrow-left" />
            </md-icon>
            <md-tooltip md-delay="300">Go back</md-tooltip>
          </md-button>

          <md-button class="md-icon-button custom-account-button" @click="MessagesDialogModal = true">
            <md-icon id="tour-6">
              <i class="fa fa-comments" style="font-size: 16px" />
            </md-icon>
            <md-tooltip md-delay="300">{{ $t("account_bar.messages") }}</md-tooltip>
            <div v-if="$store.state.unreadMessages > 0" class="newNotification pulse"></div>
          </md-button>

          <md-button class="md-icon-button custom-account-button" @click="NotificationsDialogModal = true">
            <md-icon id="tour-7">
              <i class="fa fa-bell" style="font-size: 16px" />
            </md-icon>
            <md-tooltip md-delay="300">{{ $t("account_bar.notifications") }}</md-tooltip>
            <div v-if="$store.state.unreadNotifications > 0" class="newNotification pulse"></div>
          </md-button>

          <md-button class="acc-button custom-account-avatar" :md-ripple="false" id="home-tour-3" @click="accountSettingsModal = true">
            <md-avatar class="md-medium">
              <img v-if="$store.state.user.image != null" :src="$imageus + $store.state.user.image + '?width=300'" alt="Avatar" />
              <img v-if="$store.state.user.image == null" src="/static/500x500-user.png" alt="Avatar" />
              <md-tooltip md-delay="300">{{ $t("account_bar.my_account") }}</md-tooltip>
            </md-avatar>
          </md-button>
        </div>
      </md-toolbar>
    </template>
    <template v-else>
      <div class="header-login-container">
        <el-button size="mini" round type="primary" @click="goPath('login')">{{ $t("loginText") }}</el-button>
        <el-button size="mini" round type="primary" @click="goPath('register')">{{ $t("registerText") }}</el-button>
      </div>
    </template>

    <!-- <md-dialog :md-active.sync="accountSettingsModal" class="modalRadius custom-accountsettings-dialog"
      :md-click-outside-to-close="false">
      <div class="custom-dialog-header">
        <i class="fa fa-arrow-left" @click="accountSettingsModal = false"></i>
        <p>{{ $t("account_settings.settings") }}</p>
      </div>
      <AccountSettings @userClicked="accountSettingsModal = false" />
    </md-dialog> -->

    <!-- <md-dialog :md-active.sync="MessagesDialogModal" class="modalRadius custom-messages-dialog"
      :md-click-outside-to-close="false">
      <div class="custom-dialog-header">
        <i class="fa fa-arrow-left" @click="MessagesDialogModal = false"></i>
        <p>{{ $t("contacts_hub.title") }}</p>
      </div>
      <MessagesDialog @userClicked="MessagesDialogModal = false" />
    </md-dialog> -->

    <!-- <md-dialog :md-active.sync="userProfileModal" class="modalRadius custom-userprofile-dialog"
      :md-click-outside-to-close="false">
      <div class="custom-dialog-header">
        <i class="fa fa-arrow-left" @click="userProfileModal = false"></i>
        <p>{{ $t("account_settings.profile.title") }}</p>
      </div>
      <UserProfileDialog @userClicked="userProfileModal = false" />
    </md-dialog> -->

    <!-- <md-dialog
      :md-active.sync="NotificationsDialogModal"
      class="modalRadius custom-notification-dialog"
      :md-click-outside-to-close="false"
    >
      <div class="custom-notify-dialog-header">
        <i
          class="fa fa-arrow-left"
          @click="NotificationsDialogModal = false"
        ></i>
        <p>{{ $t("account_bar.notifications") }}</p>
        <div class="d-flex">
          <portal-target name="actions-buttons"></portal-target>
        </div>
      </div>
    </md-dialog> -->

    <el-dialog :visible.sync="accountSettingsModal" class="default" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('account_settings.settings')">
      <AccountSettings @closeDialog="accountSettingsModal = false" />
    </el-dialog>

    <el-dialog :visible.sync="userProfileModal" class="medium" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('account_settings.profile.title')">
      <UserProfileDialog @closeDialog="userProfileModal = false" />
    </el-dialog>

    <el-dialog :visible.sync="MessagesDialogModal" class="custom-messages-dialog primary" :class="innerWidth <= 768 ? 'mobile-dialog' : ''" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('contacts_hub.title')">
      <MessagesDialog @closeDialog="MessagesDialogModal = false" v-if="MessagesDialogModal" />
    </el-dialog>

    <el-dialog :visible.sync="NotificationsDialogModal" class="default primary" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('account_bar.notifications')">
      <NotificationsDialog @closeDialog="NotificationsDialogModal = false" v-if="NotificationsDialogModal" />
    </el-dialog>
    <!-- <md-dialog
      :md-active.sync="ProgramDetailDialogModal"
      class="modalRadius custom-programdetail-dialog"
      :md-click-outside-to-close="false"
      :key="ProgramDetailDialogModal"
    >
      <div class="custom-dialog-header">
        <i
          class="fa fa-arrow-left"
          @click="
            ProgramDetailDialogModal = false;
            activeTab = null;
          "
        ></i>
        <p>{{ $t("program.title") }}</p>
      </div>
      <ProgramDetailDialog @userClicked="ProgramDetailDialogModal = false" />
    </md-dialog>

    <md-dialog
      :md-active.sync="SpeakerDetailDialogModal"
      class="modalRadius custom-speakerdetail-dialog"
      :md-click-outside-to-close="false"
    >
      <div class="custom-dialog-header">
        <i
          class="fa fa-arrow-left"
          @click="SpeakerDetailDialogModal = false"
        ></i>
        <p>{{ $t("speaker.title") }}</p>
      </div>
      <SpeakerDetailDialog @userClicked="SpeakerDetailDialogModal = false" />
    </md-dialog> -->

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="error.hasError" md-persistent>
      <i class="fa fa-exclamation-triangle"></i>
      <span>{{ error.message }}</span>
    </md-snackbar>

    <md-snackbar class="info" :md-position="'center'" :md-duration="4000" :md-active.sync="send_network_snack.show" md-persistent>
      <i class="fa fa-users"></i>
      <span>{{ $t("network_req_message") }}</span>
    </md-snackbar>

    <md-snackbar v-if="networkRequest != null" class="call" :md-position="'center'" :md-duration="15000" :md-active.sync="networkRequestNotification" md-persistent>
      <img :src="$imageus + (networkRequest.user.image == null ? host + '/static/500x500-user.png' : networkRequest.user.image) + '?width=200&height=200&mode=cover'" @click="getUser(networkRequest.user.id)" />
      <span>{{ $t("network_request_received", { name: networkRequest.user.fullName }) }}</span>
      <md-button @click="networkRequestNotification = false" class="reject">{{ $t("reject") }}</md-button>
      <md-button @click="accept" class="accept">{{ $t("accept") }}</md-button>
    </md-snackbar>

    <md-snackbar v-if="newNotificationObject != null" class="call" :md-position="'center'" :md-duration="2000" :md-active.sync="newNotification" md-persistent>
      <div style="display:flex;justify-content:space-between;align-items:center;width:100%;">
        <i class="fa fa-bell" style="font-size: 16px;"></i>
        <span>{{ newNotificationObject.Title }}</span>
        <md-button @click="openNotificationModal" class="accept">{{ $t("showNotifications") }}</md-button>
      </div>
    </md-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from "moment/min/moment-with-locales";
import AccountSettings from "../components/AccountSettings";
import MessagesDialog from "../components/MessagesDialog";
import UserProfileDialog from "../components/UserProfileDialog";
import NotificationsDialog from "../components/NotificationsDialog";

// import ProgramDetailDialog from "../components/ProgramDetailDialog";
// import SpeakerDetailDialog from "../components/SpeakerDetailDialog";
//import ProfileSettings from "../components/ProfileSettings";
//import PasswordSettings from "../components/PasswordSettings";
import $ from "jquery";
import _ from "lodash";

export default {
  name: "AccountBlock",
  components: {
    InfiniteLoading,
    AccountSettings,
    MessagesDialog,
    UserProfileDialog,
    NotificationsDialog
    // ProgramDetailDialog,
    // SpeakerDetailDialog
  },

  data() {
    return {
      tooltipActive: false,
      ok: true,
      messages: [],
      activeChats: [],
      moment,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      send_network_snack: {
        show: false,
        message: null
      },
      newNotification: false,
      newNotificationObject: null,
      timeout: null,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: false
        }
      },
      routeName: this.$route.name,
      localStorage,
      messagesSub: null,
      privateSub: null,
      networkRequestNotification: false,
      networkRequest: null,
      userModal: false,
      moment,
      user: null,
      messageBlock: false,
      message: null,
      error: {
        message: null,
        hasError: false
      },
      fullScreen: false,
      notificationsModal: false,
      accountSettingsModal: false,
      MessagesDialogModal: false,
      userProfileModal: false,
      NotificationsDialogModal: false,
      ProgramDetailDialogModal: false,
      SpeakerDetailDialogModal: false,
      tourOptions: {
        labels: {
          buttonSkip: this.$i18n.t("tourButton.buttonSkip"),
          buttonPrevious: this.$i18n.t("tourButton.buttonPrevious"),
          buttonNext: this.$i18n.t("tourButton.buttonNext"),
          buttonStop: this.$i18n.t("tourButton.buttonStop")
        }
      }
    };
  },
  beforeMount() {
    this.$store.state.sidebarIsOpen = localStorage.getItem("isOpen") == null ? true : localStorage.getItem("isOpen") == "true";
  },
  watch: {
    "$route.name": function() {
      this.routeName = this.$route.name;
      window.scrollTo(0, 0);
    },
    "$store.state.user": async function() {
      this.$socket.off("message-" + this.$store.state.user.id + "-newMessage");
      this.$socket.off("private-" + this.$store.state.user.id + "-client-network-request");
      this.$socket.off("private-" + this.$store.state.user.id + "-client-network-accept");
      this.$socket.emit("subscribe", {
        channel: "message-" + this.$store.state.user.id,
        token: ""
      });

      this.$socket.on("message-" + this.$store.state.user.id + "-newMessage", async data => {
        data = data.data;
        var index = this.$store.state.chats.findIndex(k => k.id == data.MessageGroupID);

        if (index != -1) {
          this.$store.state.chats[index].lastMessage.messageText = data.MessageText;
          this.$store.state.chats[index].lastMessage.createDate = data.CreateDate;
          this.$store.state.chats[index].lastMessageDate = data.CreateDate;
          this.$store.state.chats[index].lastMessageReceived = data.CreateDate;

          if (data.User.UserID != this.$store.state.user.id) {
            if (this.$store.state.activeChatPanelId != data.MessageGroupID) {
              this.$store.state.chats[index].unread += 1;
              this.$store.state.unreadMessages += 1;
            }
          }
        } else {
          var response = await axios.post("Chat/LoadMessageGroups", {
            skip: 0,
            take: 10
          });

          var data = [];

          response.data.data.items.map(i => {
            (i.minimized = true), (i.isActive = false), (i.messages = []);
            data.push(i);
          });

          this.$store.state.chats = data;
          this.$store.state.unreadMessages += 1;
        }
      });

      this.$socket.emit("subscribe", {
        channel: "private-" + this.$store.state.user.id,
        token: ""
      });

      this.$socket.on("private-" + this.$store.state.user.id + "-client-network-request", request => {
        if (request.eventID != axios.defaults.headers.eventID) {
          return;
        }
        this.networkRequestNotification = true;
        this.networkRequest = request;
        this.playSound();
      });

      this.$socket.on("private-" + this.$store.state.user.id + "-client-network-accept", request => {
        console.log(request);
      });
    }
  },

  computed: {
    isOpen() {
      return this.$store.state.sidebarIsOpen;
    },
    innerWidth() {
      return window.innerWidth;
    },

    getHeaderClass() {
      if (this.routeName == "home" || this.routeName == "events" || this.routeName == "incomingevents" || this.routeName == "pastevents") {
        return "light";
      }
      return "dark";
    },

    getCurrentSession() {
      if (this.routeName == "session") {
        return this.$store.state.sessions.find(k => k.id == this.$route.params.session_id);
      }
      return null;
    },
    currentRoom() {
      return this.$store.getters.getCurrentRoom;
    }
  },

  methods: {
    openNotificationModal() {
      this.newNotification = false;
      this.newNotificationObject = null;
      this.NotificationsDialogModal = true;
    },
    fullScreenChange() {
      this.fullScreen = document.webkitIsFullScreen;
    },
    goPath(name) {
      this.$router.push({ name });
    },
    goBack() {
      if (this.$route.name == "session") {
        this.$router.push({ name: "livestreams" });
      } else if (this.$route.name == "room") {
        this.$router.push({ name: "networking" });
      } else if (this.$route.name == "booth") {
        this.$router.push({ name: "stands" });
      } else if (this.$route.name == "event") {
        this.$router.push({ name: "events" });
      } else {
        this.$router.push({ name: "events" });
      }
    },

    getUser(id) {
      if (id) {
        this.$root.$emit("getProfile", id);
      }
    },

    getSession(id) {
      this.$store.dispatch("getSession", id);
    },

    playSound() {
      document.getElementById("notification_sound").play();
    },

    requestFullScreen() {
      var elem = document.documentElement;
      if (this.fullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      } else {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
      }
    },

    async accept() {
      if (this.$route.name == "networking") {
        this.$router.back();
      }
      var res = await this.$store.dispatch("joinRoom", this.networkRequest.room.id);
      if (res.data.hasError) {
        this.$message.error(res.data.message);
      } else {
        //this.$message.success(res.data.message);
      }
      this.networkRequestNotification = false;
    },

    toggleMinimize(id) {
      var index = this.$store.state.chats.findIndex(k => k.id == id);
      this.$store.state.chats[index].minimized = !this.$store.state.chats[index].minimized;
    }
  },

  created() {
    if (this.$store.state.user != null) {
      this.$socket.emit("subscribe", {
        channel: "message-" + this.$store.state.user.id,
        token: ""
      });

      this.$socket.emit("subscribe", {
        channel: "presence-user-" + this.$store.state.user.id,
        token: localStorage.getItem("token")
      });

      this.$socket.on("presence-user-" + this.$store.state.user.id + "-newNotification", data => {
        this.newNotificationObject = data.data;
        this.newNotification = true;
        this.$store.state.unreadNotifications += 1;

        setTimeout(() => {
          this.newNotification = false;
          this.newNotificationObject = null;
        }, 3000);
      });

      this.$socket.on("message-" + this.$store.state.user.id + "-newMessage", async data => {
        data = data.data;
        var index = this.$store.state.chats.findIndex(k => k.id == data.MessageGroupID);

        if (index != -1) {
          this.$store.state.chats[index].lastMessage.messageText = data.MessageText;
          this.$store.state.chats[index].lastMessage.createDate = data.CreateDate;
          this.$store.state.chats[index].lastMessageDate = data.CreateDate;
          this.$store.state.chats[index].lastMessageReceived = data.CreateDate;

          if (data.User.UserID != this.$store.state.user.id) {
            if (this.$store.state.activeChatPanelId != data.MessageGroupID) {
              this.$store.state.chats[index].unread += 1;
              this.$store.state.unreadMessages += 1;
            }
          }
        } else {
          var response = await axios.post("Chat/LoadMessageGroups", {
            skip: 0,
            take: 10
          });

          var data = [];

          response.data.data.items.map(i => {
            (i.minimized = true), (i.isActive = false), (i.messages = []);
            data.push(i);
          });

          this.$store.state.chats = data;
          this.$store.state.unreadMessages += 1;
        }
      });

      this.$socket.emit("subscribe", {
        channel: "private-" + this.$store.state.user.id,
        token: ""
      });

      this.$socket.on("private-" + this.$store.state.user.id + "-client-network-request", request => {
        if (request.eventID != axios.defaults.headers.eventID) {
          return;
        }
        this.networkRequestNotification = true;
        this.networkRequest = request;
        this.playSound();
      });

      this.$socket.on("private-" + this.$store.state.user.id + "-client-network-accept", request => {
        console.log(request);
      });
    }
  },
  beforeMount() {
    // this.fullScreen = document.fullscreen;
  },
  mounted() {
    var self = this;
    document.addEventListener("fullscreenchange", self.fullScreenChange);

    this.$root.$on("accountSettingsModal", () => {
      this.accountSettingsModal = true;
    });

    this.$root.$on("passwordSettingsModal", () => {
      this.passwordSettingsModal = true;
    });

    this.$root.$on("MessagesDialogModal", () => {
      this.MessagesDialogModal = true;
    });

    this.$root.$on("NotificationsDialogModal", () => {
      this.NotificationsDialogModal = true;
    });

    // this.$root.$on("ProgramDetailDialogModal", id => {
    //   this.$store.state.currentEventProgram = id;
    //   this.ProgramDetailDialogModal = true;
    //   if (this.SpeakerDetailDialogModal == true) {
    //     this.SpeakerDetailDialogModal = false;
    //   }
    // });

    // this.$root.$on("SpeakerDetailDialogModal", id => {
    //   this.$store.state.currentSpeakerProfile = id;
    //   this.SpeakerDetailDialogModal = true;
    //   if (this.ProgramDetailDialogModal == true) {
    //     this.ProgramDetailDialogModal = false;
    //   }
    // });

    this.$root.$on("getProfile", id => {
      if (id == null) return;
      axios.get("profile/get?userID=" + id).then(res => {
        this.$store.state.currentUserProfile = res.data.data.item;
        this.$store.state.currentUserProfile.sameEvents = res.data.data.sameEvents.items;
        this.ProgramDetailDialogModal = false;
        // this.MessagesDialogModal = false;
        this.userProfileModal = true;
      });
    });

    this.$root.$on("network-request", id => {
      if (this.currentRoom.users.length >= this.currentRoom.peopleCount) {
        this.$root.$emit("error", this.$t("odadolu"));
        return;
      }

      this.$socket.emit("emit-private-room", {
        data: {
          user: this.$store.state.user,
          room: this.currentRoom,
          eventID: axios.defaults.headers.eventID,
          event: "client-network-request"
        },
        channel: "private-" + id
      });

      this.$message.success(this.$t("network_req_message"));
    });
  },

  beforeDestroy() {
    var self = this;
    document.removeEventListener("fullscreenchange", self.fullScreenChange());

    this.$root.$off("network-request");
    this.$root.$off("accountSettingsModal");
    this.$root.$off("passwordSettingsModal");
    this.$root.$off("MessagesDialogModal");
    this.$root.$off("NotificationsDialogModal");
    // this.$root.$off("ProgramDetailDialogModal");
    // this.$root.$off("SpeakerDetailDialogModal");
    this.$root.$off("getProfile");
    if (this.$store.user) {
      this.$socket.off("message-" + this.$store.state.user.id + "-newMessage");
      this.$socket.off("private-" + this.$store.state.user.id + "-client-network-request");
      this.$socket.off("private-" + this.$store.state.user.id + "-client-network-accept");
    }
  }
};
</script>

<style>
.v-tour {
  z-index: 999999;
}
</style>

<style lang="less">
.header-login-container {
  height: 55px;
  padding: 10px;

  background: white;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  @media screen and (max-width: 991px) {
    overflow: hidden;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
}
#accountblock {
  width: 100%;

  .wlabelclass {
    width: auto;
    height: 100%;
    width: auto;
    aspect-ratio: 1;
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 6px;
    overflow: hidden;
    margin-left: 20px;
    padding: 2px;
  }

  .md-button:before {
    position: unset;
    display: none;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    opacity: 0;
    -webkit-transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: background-color, opacity;
    content: unset;
  }

  .md-avatar {
    width: 36px !important;
    height: 36px !important;
    min-width: unset !important;
  }

  .md-toolbar {
    min-height: 55px;
  }

  .logo {
    height: 30px;
  }

  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    box-shadow: unset !important;
    padding: 0;
    transition: 0.3s;

    .toolbar-inner-flex {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      width: 80px;

      .custom-account-avatar {
        margin-top: 10px;
      }

      .mobile-logo {
        img {
          display: none;
        }
      }
    }

    .toolbar-inner-grid {
      display: grid;
      grid-template-columns: 3fr 1fr 1fr 1fr 1fr;
      align-items: center;
      justify-content: center;
      max-width: 350px;
      width: 100%;

      .mobile-logo {
        img {
          display: none;
        }
      }

      .custom-account-button-first {
        display: block;
      }

      .custom-account-button {
        display: contents;
      }

      .custom-account-avatar {
        display: contents;
      }
    }
  }

  .acc-button .md-ripple .md-button-content {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .session {
    width: 260px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &:hover {
      background-color: rgba(51, 58, 72, 0.9);
      cursor: pointer;
    }

    padding-right: 10px;

    .session-left {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;

      color: white;
      margin-left: 10px;
    }

    .session-right {
      button {
        border: none;
        outline: none;
        padding: 5px 10px;
        background-color: whitesmoke;
        font-weight: bold;
        color: white;
        border-radius: 3px;
        font-family: "Roboto";
      }
    }
  }
}

#chat {
  width: 280px;
  box-sizing: border-box;

  ul {
    margin: 0;
    padding: 0;

    .md-list-item {
      padding: 0px;

      .md-list-item-content {
        padding: 0;

        &.unread {
          background-color: whitesmoke;
        }

        &:hover {
          background-color: whitesmoke;
          cursor: pointer;
        }

        .chat-title {
          display: block;
          font-weight: 600;
          font-size: 14px;
        }

        .chat-time {
          font-size: 12px;
          color: silver;
          display: inline-block;
        }

        .chat-text {
          font-size: 12px;
          color: gray;
        }

        .chat-detail {
          line-height: 14px;
          display: flex;
          flex: 1;
          flex-direction: column;
        }

        .unread-count {
          color: white;
          font-size: 12px;
          padding: 0px 5px;
          border-radius: 10px;
          margin-right: 5px;
        }

        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 10px;
          margin-left: 10px;
          border: 4px solid #ddd;
        }
      }

      display: flex;
      flex-direction: row;
      padding: 0px 0;
      align-items: center;
      border-bottom: 1px solid whitesmoke;
    }
  }
}

.notifications {
  .notification {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 15px;

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }

    .notify-left {
      img {
        border: 4px solid rgb(221, 221, 221);
      }

      margin-right: 10px;
    }

    .notify-right {
      img {
        border-radius: 5px;
      }

      margin-right: 5px;
    }

    h3,
    p {
      margin: 0;
      font-size: 13px;
    }

    p {
      line-height: 12px;
    }
  }
}

.md-tooltip {
  z-index: 99999 !important;
}

.dialogHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #03658c;
  border-radius: 2px;
}

.newNotification {
  position: absolute;
  right: 3px;
  top: 3px;
  z-index: 1;
}

@media (max-width: 768px) {
  #accountblock {
    .md-button:before {
      position: unset;
      display: none;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      opacity: 0;
      -webkit-transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      will-change: background-color, opacity;
      content: unset;
    }

    .toolbar-inner-grid,
    .toolbar-inner-flex {
      display: grid !important;
      grid-template-columns: 3fr 1fr 1fr 1fr 1fr !important;
      align-items: center !important;
      justify-content: center !important;
      max-width: 100% !important;

      .mobile-logo {
        img {
          cursor: pointer;
          height: 26px;
          margin-left: 8px;
          display: block !important;
        }
      }

      .custom-account-button-first {
        display: block;
      }

      .custom-account-button {
        display: contents;
      }

      .custom-account-avatar {
        display: contents;

        .md-ripple {
          .md-button-content {
            .md-avatar {
              width: 36px !important;
              height: 36px !important;
              min-width: unset !important;
            }
          }
        }
      }
    }
  }

  .modalRadius {
    border-radius: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/AccountBlock.vue